import { stringify, parse } from 'pkg/json';

export enum LocalStorageKeys {
	AuthToken = 'authToken',
	AccountToken = 'accountToken',
	Organizations = 'organizations',
	ActiveMembership = 'activeMembership',
	ActiveOrganizationId = 'activeOrganizationId',
	CalendarFilters = 'calendarFilters',
	UserLogin = 'userLogin',
	SplashScreen = 'splashScreen',
	CollapsedDrawer = 'collapsedDrawer',
	DarkMode = 'darkMode',
	FormCategoriesView = 'formCategoriesView',
	ContactListView = 'contactListView',
	SubscriptionView = 'subscriptionView',
	InvoiceView = 'invoiceView',
	ProductView = 'productView',
	RegistrationsView = 'registrationsView',
	PostView = 'postView',
	DiscountsView = 'discountsView',
	PayoutView = 'payoutView',
	SinglePayoutView = 'singlePayoutView',
	FormSubmissionsView = 'formSubmissionsView',
	FormInvitationsView = 'formInvitationsView',
	FormSubmissionColumns = 'formSubmissionColumns',
	ActivityParticipantsView = 'activityParticipantsView',
	ActivityWaitlistView = 'activityWaitlistView',
	ActivityScheduleView = 'activityScheduleView',
	InvoiceTableFields = 'invoiceTableFields',
	InvoiceTableHiddenFields = 'invoiceTableHiddenFields',
	CompetitionGamesView = 'competitionGamesView',
	TournamentGamesView = 'tournamentGamesView',
	TournamentGroupsView = 'tournamentGroupsView',
	TrainingLibraryView = 'trainingLibraryView',
	PracticePlannerPickerView = 'practicePlannerPickerView',
	FormWorkspaceActivitiesSeen = 'formWorkspaceActivitiesSeen',
	AppRating = 'appRating',
	DrawingNumberPlayers = 'drawingNumberPlayers',
	WaitlistInviteBookings = 'waitlistInviteBookings',
	UnsentAnnouncementViews = 'unsentAnnouncementViews',
}

export function getItem(key: LocalStorageKeys) {
	return localStorage.getItem(key);
}

export function getJsonItem<T>(key: LocalStorageKeys) {
	return parse<T>(localStorage.getItem(key));
}

export function setItem(key: LocalStorageKeys, value: string) {
	return localStorage.setItem(key, value);
}

export function setJsonItem<T>(key: LocalStorageKeys, values: T) {
	return localStorage.setItem(key, stringify(values));
}

export function removeItem(key: LocalStorageKeys) {
	return localStorage.removeItem(key);
}

export function removeItems(...keys: LocalStorageKeys[]) {
	return keys.forEach((key) => localStorage.removeItem(key));
}
